<template>
  <div>
    <el-form class="el-form-m20" :inline="true" size="small">
      <el-form-item class="search-bar">
        <el-input :class="{'w-30vw':normal,'w-100per':!normal}"
                  placeholder="请输入姓名或试卷名" v-model="searchValue">
          <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item v-if="normal">
        <el-button-group>
          <el-button v-if="perm.indexOf('score:delete') > -1" type="danger" icon="el-icon-delete"
                     @click="deleteSlt">批量删除
          </el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table
        ref="scoreTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="scoreId"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="scoreId" label="编号" width="100" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="stuName" label="姓名" width="100">
      </el-table-column>
      <el-table-column prop="paperName" label="备注 / 工种">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" width="180">
      </el-table-column>
      <el-table-column prop="idNumber" label="身份证号" width="280">
      </el-table-column>
      <el-table-column prop="score" label="成绩" width="60">
      </el-table-column>
      <el-table-column prop="tpGrouping" label="试卷号" width="160">
      </el-table-column>
      <el-table-column v-if="normal" label="操作">
        <template slot-scope="scope">
          <el-link v-if="perm.indexOf('score:detail') > -1"
                   type="primary"
                   icon="el-icon-view"
                   @click="testPaperDetails(scope.$index, scope.row)">查看试卷详情
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :layout="normal ? 'sizes, prev, pager, next' : 'prev, pager, next'"
        :page-size="size"
        :total="total"
        :current-page.sync="index"
        @size-change="sizeChange"
        @current-change="currentChange">
    </el-pagination>
    <el-dialog class="padding-top-0" width="50%" :title="title" :visible.sync="dialogVisible" top="1vh">
      <template v-for="(item,i) in topicList">
        <div class="question">
          <div class="title">{{ (i + 1) }}、{{ item['topic'] }}（{{ mapQuestionType[item['questionType']] }}题
            {{ correctAnswer[i].score }} 分）
          </div>
          <div class="test-question">
            <label v-for="answer in createAnswerOption(item['answer'])">
              <div class="answer-item">{{ answer['value'] }}、{{ answer['label'] }}</div>
            </label>
          </div>
          <div>正确答案：{{ formatCorrectAnswer(correctAnswer[i].ca) }}
          </div>
          <div
              :class="formatCorrectAnswer(correctAnswer[i].ca)!==formatUserAnswer(userAnswer[i]) ? 'answer-error':'primary-color'">
            考生答案：{{ formatUserAnswer(userAnswer[i]) }}
          </div>
        </div>
      </template>

    </el-dialog>
  </div>
</template>

<script>
import helper from "@/common/CZHelper";

export default {
  name: "Score",
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  beforeRouteEnter(to, from, next) {
    //获取不了this，会携带请求头
    next(self => {
      self.getList();
    });
  },
  methods: {
    // 创建答案选项
    createAnswerOption(args) {
      let array = args.split(this.separator);
      let answer = [];
      array.forEach((item, i) => {
        answer.push({
          value: this.letter[i],
          label: item
        });
      });
      return answer;
    },
    formatCorrectAnswer(answer) {
      let fmt = answer === "1" ? "正确" : answer === "0" ? "错误" : answer
      return fmt.indexOf(this.separator) > -1 ? fmt.split(this.separator).sort().join("、") : fmt;
    },
    formatUserAnswer(answer) {
      if (Array.isArray(answer) && answer.length > 0) return answer.join("、");
      else if (typeof answer === 'number') return answer === 1 ? "正确" : "错误";
      else return answer.length > 0 ? answer : "考生未答题";
    },
    tableRowClassName({row, rowIndex}) {
      return row.score < 60 ? 'lg60' : '';
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size,
        score: JSON.stringify(this.score)
      };
      this.groupList = [];
      helper.getList(this.apiUrl + 'list', params, this);
    },
    search() {
      this.index = 1;
      this.score.paperName = this.score.stuName = this.searchValue
      this.getList();
    },
    clearSelection() {
      this.selectedRows.length = 0;
      this.$refs['scoreTable'].clearSelection();
    },
    handleSelectionChange(val) {
      // 非页面展示（对话框模式），触发事件
      if (!this.normal) this.$emit("rowSelected", val);
      this.selectedRows = val;
    },
    deleteSlt() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        if (this.selectedRows.length <= 0) return;
        this.$axios.post(this.apiUrl + 'remove', {ids: this.selectedRows.map(item => item.scoreId).join(",")}).then(({data}) => {
          if (data.code === 200) {
            this.clearSelection();
            this.getList();
          } else
            this.$message.error("删除失败，稍后再试");
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    testPaperDetails(rowIndex, row) {
      this.$axios.post(this.apiUrl + 'one', {id: row['scoreId']}).then(({data}) => {
        if (data) {
          this.title = data.stuName + " / " + data.score + " 分 - 试卷详情";
          this.dialogVisible = true;
          this.tpDetails = JSON.parse(data.testPaperDetail);
          this.topicList = this.tpDetails.topicList;
          this.userAnswer = this.tpDetails.userAnswer;
          this.correctAnswer = this.tpDetails.correctAnswer;
        } else {
          this.$message.error("数据获取失败");
        }
      });
    }
  },
  data() {
    return {
      title: "试卷详情",
      dialogVisible: false,
      mapQuestionType: {"rightAndWrong": "对错", "check": "多选", "radio": "单选"},
      apiUrl: process.env.VUE_APP_URL + "ma/score/",
      perm: localStorage.getItem('perm').split(","),
      list: [],
      separator: "*#",
      tpDetails: null,
      searchValue: '',
      total: 0,
      letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
      size: this.normal ? 10 : 6,
      index: 1,
      selectedRows: [],
      score: {
        "paperName": null,
        "stuName": null
      },
      topicList: [],
      userAnswer: {},
      correctAnswer: {}
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";


.answer-error {
  color: darkred;
}

.padding-top-0 {
  padding-top: 0 !important;
}

.answer-item {
  margin: 8px 0;
}

.primary-color {
  color: teal;
}

.warning-color {
  color: #E6A23C;
}

.el-form-m20 {
  margin: 0 10px;
  /*text-align: right;*/
}

.question {
  /*padding: 8px 10px;*/
  border-top: 1px dashed teal;
  padding: 1em 0;
  /*border-bottom: 1px solid teal;*/
}

/*最后一个不要边框*/
.question:first-of-type {
  border-top: 0;
  padding: 0 0 1em 0;
}

.title {
  font-size: 1.2em;
  /*margin: 1em 0;*/
}

.test-question {
  font-size: 1em;
}

</style>